import React from 'react'
import { Link } from 'react-router-dom'
import { NavbarTwo } from '../components/Layout/Navbar'
import Footer from '../components/Layout/Footer'
import BottomEndPlug from "../asset/precisionone/bottomend.png"
import CAPSULE from "../asset/precisionone/capsule.png"
import LINK from "../asset/precisionone/link.png"
import TopEnd from "../asset/precisionone/topend.png"
import Pinion from "../asset/precisionone/pinion.png"
import Capsuletwo from "../asset/precisionone/capsule2.png"
import Poppet from "../asset/precisionone/poppet.png"
import PoppetTwo from "../asset/precisionone/poppettwo.png"
import Valve from "../asset/precisionone/valve.png"
import LVDT from "../asset/precisionone/lvdt.png"
import Feed from "../asset/precisionone/feed.png"
import Valvetwo from "../asset/precisionone/valvetwo.png"
import AssemblyConnectionFlangeOne from "../asset/precisiontwo/1.png"
import AssemblyConnectionFlangeTwo from "../asset/precisiontwo/2.png"
import AssemblyConnectionFlangeThree from "../asset/precisiontwo/3.png"
import AssemblySplitCollar from "../asset/precisiontwo/4.png"
import AssemblyBagueArretD40 from "../asset/precisiontwo/5.png"
import AssemblySupportClampOne from "../asset/precisiontwo/6.png"
import AssemblyBagueArretD50 from "../asset/precisiontwo/7.png"
import AssemblyAdaptor from "../asset/precisiontwo/9.png"
import AssemblyTip from "../asset/precisiontwo/10.png"
import AssemblySpacingCone from "../asset/precisiontwo/8.png"
import AssemblyFlatBar from "../asset/precisiontwo/11.png"
import AssemblyFramePlate from "../asset/precisiontwo/12.png"
import PrecisionTwo from '../components/Precision/PrecisionTwo'
import "./ProductDetail.css";

const assemblyComponents = [
  [AssemblyConnectionFlangeOne, "CONNECTION FLANGE - I"],
  [AssemblyConnectionFlangeTwo, "CONNECTION FLANGE - II"],
  [AssemblyConnectionFlangeThree, "CONNECTION FLANGE - III"],
  [AssemblySplitCollar, "SPLIT COLLAR"],
  [AssemblyBagueArretD40, "BAGUE ARRET D40"],
  [AssemblySupportClampOne, "SUPPORT CLAMP - I"],
  [AssemblyBagueArretD50, "BAGUE ARRET D50"],
  [AssemblyAdaptor, "ADAPTOR"],
  [AssemblyTip, "TIP 005"],
  [AssemblySpacingCone, "SPACING CONE"],
  [AssemblyFlatBar, "FLAT BAR"],
  [AssemblyFramePlate, "FRAME PLATE"],
];
const PrecisionComponentOne = () => {
  return (
    <div className="product-detail-page product-detail-page--precision-one">
    <NavbarTwo />
    <div className='2xl:pt-[120px] pt-[80px] xl:pt-[110px] lg:pt-[100px]'>
        <div className='bg-gray-200  lg:pb-12 pb-4 px-4 lg:px-12'>
            <div className='flex items-center justify-center flex-col' >
            <h3 className='lg:text-[2.2rem] text-[1.2rem] mb-5 bg-gradient-to-r from-[#99821d] via-[#ccc595] to-[#9d8944] inline-block text-transparent bg-clip-text uppercase lg:leading-[2.5rem] font-[GilroyBold]' >PRECISION COMPONENTS</h3>
            <p className='text-gray-600 text-[.8rem] text-center xl:text-[1rem]'>We offer a wide range of precision-engineered components, including Poppets, Plugs, Pins, Valves Piston etc. Manufactured from high-performance materials such as Stainless Steel, Titanium, Incoloy, Inconel, 17-4 pH with required heat treated condition, our components are designed with tight tolerances of up to 2 microns and Ra finishes up to 0.02Ra. These parts are ideal for use in power and energy sectors providing durable and reliable solutions for various applications.</p>
            <p className='text-gray-600 text-[.8rem] text-center xl:text-[1rem] mt-4'>We specialize in manufacturing high-precision components with diameters up to 1000 mm, offering exceptional geometric tolerances such as concentricity, straightness, run-out, total run-out, and circularity. Our capabilities extend to working with exotic materials, ensuring durable and reliable solutions for diverse industrial applications. With an in-house heat treatment furnace for processing raw materials up to 500 mm, we guarantee optimal material properties and performance. Whether you need custom sizes, advanced materials, or tight tolerances, our team delivers precision-engineered components that meet the highest standards.</p>
            </div>
            <div className='py-6 lg:py-12' >
                <div className='grid grid-cols-1 my-6 xl:gap-12 gap-6 lg:grid-cols-4' >
                   {assemblyComponents.map(([image, title]) => (
                     <div key={title}>
                       <img className='rounded-lg' src={image} alt={title} />
                       <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem]'>{title}</h6>
                     </div>
                   ))}
                   <div>
                    <img className='rounded-lg' src={BottomEndPlug} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >BOTTOM END PLUG</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={CAPSULE} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >CAPSULE</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={LINK} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >LINK</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={TopEnd} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >TOP END PLUG</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={Pinion} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >PINION EXTENSION</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={Capsuletwo} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >CAPSULE</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={Poppet} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >POPPET </h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={Valve} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >VALVE PISTON</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={LVDT} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >LVDT SLEEVE</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={PoppetTwo} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >POPPET -II</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={Feed} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >FEED ROD</h6>
                   </div>
                   <div>
                    <img className='rounded-lg' src={Valvetwo} />
                    <h6 className='text-center mt-2 xl:text-[.8rem] text-[.7rem] ' >VALVE PISTON</h6>
                   </div>
                </div>
           </div>
           <PrecisionTwo />
           <section className='mt-8 lg:mt-16 rounded-lg bg-[#202326] px-6 py-10 text-center lg:px-12 lg:py-14'>
             <h4 className='text-[1.4rem] lg:text-[2rem] font-[GilroyBold] text-white'>More precision products are coming soon</h4>
             <p className='mx-auto mt-3 max-w-2xl text-[.9rem] leading-7 text-gray-300 lg:text-[1rem]'>Our team is working on more products every day, with new products coming soon. Connect with us through our office, phone, or email.</p>
             <Link className='mt-6 inline-block rounded-md bg-[#99821d] px-6 py-3 text-[.9rem] font-[GilroyMedium] text-white transition hover:bg-[#b39b43]' to='/contact'>Connect now</Link>
           </section>
        </div>
    <Footer />
    </div>
</div>
  )
}

export default PrecisionComponentOne
